import React from 'react';

export const StatCard = ({ title, value, subtext, icon: Icon, color, testId }) => (
  <div className="bg-white rounded-2xl p-5 border border-slate-100" data-testid={testId}>
    <div className="flex items-start justify-between mb-2">
      <span className="text-xs font-medium text-slate-500 uppercase tracking-wide">{title}</span>
      <div className={`w-9 h-9 ${color} rounded-xl flex items-center justify-center`}>
        <Icon size={18} className="text-white" weight="bold" />
      </div>
    </div>
    <p className="text-2xl font-bold text-slate-900">{value}</p>
    {subtext && <p className="text-xs text-slate-500 mt-0.5">{subtext}</p>}
  </div>
);
